module.exports = __webpack_public_path__ + "img/icon_xing.svg?version=c60ed7b5";